import { useFrame } from '@react-three/fiber'
import { Vector3 } from 'three'
import { useConfigurator } from './ConfiguratorContext'

const CAMERA_PRESETS = {
    null: { position: [6, 1, 0], target: [0, 1, 0] },
    body: { position: [3, 0.5, 4], target: [0, 1.0, 0] },
    wheels: { position: [3.2, 0.4, 1.5], target: [-0.9, 0.3, 1.6] },
    interior: { position: [1.2, 1.1, 0.3], target: [0, 0.8, -0.2] },
}

const _targetPos = new Vector3()
const _targetLook = new Vector3()

export default function CameraAnimator({ orbitControlsRef }) {
    const { activeCategory } = useConfigurator()

    useFrame((state, delta) => {
        const controls = orbitControlsRef?.current
        if (!controls) return

        const preset = CAMERA_PRESETS[activeCategory] || CAMERA_PRESETS[null]
        _targetPos.set(...preset.position)
        _targetLook.set(...preset.target)

        const t = 1 - Math.pow(0.001, delta)

        state.camera.position.lerp(_targetPos, t)
        controls.target.lerp(_targetLook, t)
        controls.update()
    })

    return null
}
